import { startUpdateAnnotation } from '@/stores/explore';
import { useLayout } from '@/stores/layout';
import { useViewer } from '@/stores/viewer';
import { persist } from '@/utils/Persist';
import { atom, useAtom } from 'jotai';
import { useEffect } from 'react';

const initialCameraOverrideAtom = atom(true);

// Set the initial camera position and annotation select from persist storage
export const useSetInitialCameraPositionAndAnnotation = () => {
  const [initialCameraOverride, setInitialCameraOverride] = useAtom(initialCameraOverrideAtom);

  const api3D = useViewer(state => state.api3D);
  const api2D = useViewer(state => state.api2D);
  const annotationGroups = useViewer(state => state.annotationGroups);

  // Set the initial camera position and annotation select from persist storage
  useEffect(() => {
    if (!api3D || !api2D || !initialCameraOverride) return;

    const persistAnnotation = persist.get('annotation');
    const persistCameraPosition = persist.get('cameraPosition');
    const persistCameraRotation = persist.get('cameraRotation');
    const persistCameraState = persist.get('orthoMatrix');

    if (persistCameraPosition && persistCameraRotation) {
      api3D.navigation.moveTo(persistCameraPosition, persistCameraRotation);
      if (persistCameraState) {
        api3D.navigation.setOrthoMatrixParams(persistCameraState);
      }
      setInitialCameraOverride(false);
    } else if (persistAnnotation) {
      const annotation = annotationGroups
        .flatMap(group => group.annotations)
        .find(annotation => annotation.id === persistAnnotation);

      if (annotation?.sketch3D) {
        api3D.navigation.lookAt(annotation.sketch3D, false);
        startUpdateAnnotation(annotation.metadata, annotation.template);
        setInitialCameraOverride(false);
      } else if (annotation?.sketch2D) {
        api2D.editor.lookAt(annotation.sketch2D);
        startUpdateAnnotation(annotation.metadata, annotation.template);
        setInitialCameraOverride(false);
      }
    } else {
      setInitialCameraOverride(false);
    }
  }, [annotationGroups, api2D, api3D, initialCameraOverride, setInitialCameraOverride]);

  // Open initial annotation from persist storage
  useEffect(() => {
    const persistAnnotation = persist.get('annotation');

    const annotation = annotationGroups
      .flatMap(group => group.annotations)
      .find(annotation => annotation.id === persistAnnotation);

    // Only start update annotation if the annotation has not been started
    if (annotation?.sketch3D && !useLayout.getState().isShowingRightSideBar) {
      startUpdateAnnotation(annotation.metadata, annotation.template);
    }
  }, [annotationGroups]);
};
